import { FC, useState, useEffect } from "react";
import { useStyles } from "./RemarkHistory.styles";
import { UserData } from "../../../types/org.type";
import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";

interface IProps {
  userId: number | null;
  type?: "regular" | "spv";
}

const RemarkHistory: FC<IProps> = ({ userId, type = "regular" }) => {
  const { classes } = useStyles();
  const [remark, setRemark] = useState<{ note: string; createdDate: string }>({
    note: "Loading...",
    createdDate: "",
  });

  const formatDate = (dateString: string): string => {
    try {
      if (!dateString) return "No date available";

      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return "Invalid date";
      }

      const formatter = new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: "Asia/Kuala_Lumpur",
      });

      const formatted = formatter.format(date);
      const [datePart, timePart] = formatted.split(", ");
      const [day, month, year] = datePart.split("/");
      return `${day}/${month}/${year} ${timePart}`;
    } catch (error) {
      return "Invalid date";
    }
  };

  useEffect(() => {
    if (!userId) return;

    const fetchRemark = async () => {
      try {
        const response = await axios.get(
          `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/organization/remark/${userId}?type=${type}`,
        );
        setRemark({
          note: response.data.note || "No remarks available",
          createdDate: response.data.createdDate
            ? formatDate(response.data.createdDate)
            : "No date available",
        });
      } catch (error) {
        setRemark({ note: "Error loading note", createdDate: "" });
      }
    };

    fetchRemark();
  }, [userId, type]);

  return (
    <div className={classes.noteContainer}>
      <div className={classes.inputGroup}>
        <span>{remark.note}</span>
        <p style={{ fontSize: "12px" }}>
          {remark.createdDate || "No date available"}
        </p>
      </div>
    </div>
  );
};

export default RemarkHistory;
